import { Aptos, AptosConfig, Network } from '@aptos-labs/ts-sdk';

export const aptosClient = new Aptos(
	new AptosConfig({ network: Network.MAINNET }),
);

export const TOKEN_DECIMALS = {
	APT: 8,
	USDC: 6,
	USDT: 6,
};

// Custody Vault Configuration
export const VAULT_CONFIG = {
	CONTRACT_ADDRESS: process.env.REACT_APP_CONTRACT_ADDRESS,
	MODULE_NAME: 'custody_vault_multiple',
	USDC_FA_METADATA:
		'0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b',
	MIN_DEPOSIT: 100_000, // 0.1 USDC in base units
	MIN_DEPOSIT_USDC: 0.1,
};

export type VaultConfig = typeof VAULT_CONFIG;

export const resolveVaultConfig = (
	overrides?: Partial<VaultConfig>,
): VaultConfig => ({
	...VAULT_CONFIG,
	...overrides,
});

// Vault Error Codes
export const VAULT_ERRORS: Record<number, string> = {
	1: 'Admin-only action (E_NOT_ADMIN)',
	2: 'Agent-only action (E_NOT_AGENT)',
	3: 'Amount must be at least 0.1 USDC (E_ZERO)',
	4: 'Position not found. It may have been withdrawn. (E_NO_POS)',
	5: "You don't own this position (E_NOT_OWNER)",
	6: 'Position already finalized (E_ALREADY_FINAL)',
	7: 'Position not yet finalized. Please wait for agent to complete. (E_NOT_FINAL)',
	8: 'Contract is currently paused. Please try again later. (E_PAUSED)',
	9: 'Cannot cancel - agent has already processed funds. Wait for finalization. (E_VAULT_DEFICIT)',
};
